import { IAccount } from './Models';

// const webServiceUrlBase: string = 'http://localhost:5000/';
const webServiceUrlBase: string = 'https://api.levitate.ai/';

export class WebServiceHelper {
	public buildFetchRequest = (path: string, method: string, jsonObj: any) => {
		// Define headers
		const headers = new Headers();
		headers.append('Content-Type', 'application/json; charset=utf-8');
		headers.append('Accept', 'application/json');

		const url = webServiceUrlBase + path;
		const config: RequestInit = {
			headers,
			method,
			mode: 'cors',
			redirect: 'follow',
		};

		if (method.toLowerCase() !== 'get' && method.toLowerCase() !== 'delete' && jsonObj !== null) {
			config.body = JSON.stringify(jsonObj);
		}

		const request = new Request(url, config);
		return request;
	}

	public callWaitlistWebService = (email: string, submissionCallback: any) => {
		// Define headers
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');

		// Create request object
		const url: string = webServiceUrlBase + 'waitlist';
		const request = new Request(url, {
			body: JSON.stringify({firstName: email, lastName: email, email}),
			headers,
			method: 'POST',
			mode: 'cors',
			redirect: 'follow',
		});

		fetch(request).then(submissionCallback);
	}

	public createFreeTrial = async (companyName: string, emailAddress: string, submissionCallback: any) => {
		// Trim the email address, just in case
		emailAddress = emailAddress.trim();

		// Define headers
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');

		const account: IAccount = {};
		account.companyName = companyName;
		account.planDetails = {};
		account.planDetails.planId = 1;

		// Create request object
		const url: string = webServiceUrlBase + 'account/marketing?emailAddress=' + encodeURIComponent(emailAddress);
		const request = new Request(url, {
			body: JSON.stringify(account),
			headers,
			method: 'POST',
			mode: 'cors',
			redirect: 'follow',
		});

		try {
			const response = await fetch(request);
			submissionCallback(response);
		} catch (e) {
			const responseError = { ok: false, status: 500, statusText: e.message };
			submissionCallback(responseError);
		}
	}

	public createPersonalAccount = async (name: string, emailAddress: string, submissionCallback: any) => {
		// Trim the email address, just in case
		emailAddress = emailAddress.trim();

		// Define headers
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Accept', 'application/json');

		const account: IAccount = {};
		account.companyName = name;
		account.planDetails = {};
		account.planDetails.planId = 0;

		// Create request object
		const url: string = webServiceUrlBase + 'account/marketing?emailAddress=' + encodeURIComponent(emailAddress);
		const request = new Request(url, {
			body: JSON.stringify(account),
			headers,
			method: 'POST',
			mode: 'cors',
			redirect: 'follow',
		});

		try {
			const response = await fetch(request);
			submissionCallback(response);
		} catch (e) {
			const responseError = { ok: false, status: 500, statusText: e.message };
			submissionCallback(responseError);
		}
	}
}
